module.exports = __webpack_public_path__ + "img/31.e4f16d74.jpg";